module.exports = __webpack_public_path__ + "static/media/link_01.70866b24.jpg";